import { jsx as _jsx } from "react/jsx-runtime";
import { ArtifactCard } from './ArtifactCard.js';
import { ArtifactThumb } from './ArtifactThumb.js';
import { useViewer } from './primitives.js';
/**
 * Every transcript surface uses this boundary, including collapsed groups and progress.
 * `thumb` is the compact tile (progress grids, compare); `card` is the transcript's full card.
 */
export function ArtifactPresentation({ artifact, variant = 'thumb', }) {
    const viewer = useViewer();
    if (viewer.renderArtifact)
        return viewer.renderArtifact(artifact, { variant });
    if (viewer.encryptedArtifacts ||
        artifact.encrypted !== undefined ||
        artifact.thumbEncrypted !== undefined)
        return variant === 'card' ? (_jsx(ArtifactCard, { artifact: artifact, locked: true })) : (_jsx("span", { role: "status", children: "Attachment locked or unavailable" }));
    return variant === 'card' ? (_jsx(ArtifactCard, { artifact: artifact })) : (_jsx(ArtifactThumb, { artifact: artifact, state: artifact.state }));
}
/** Inline images with artifact ids wait for authenticated completion refs too. */
export function ArtifactImage({ image, className }) {
    const viewer = useViewer();
    if (image.artifactId) {
        const artifact = viewer.artifactById?.(image.artifactId);
        if (artifact)
            return _jsx(ArtifactPresentation, { artifact: artifact });
        if (viewer.encryptedArtifacts)
            return _jsx("span", { role: "status", children: "Attachment locked or unavailable" });
    }
    const src = image.url ??
        (image.dataBase64 && /^image\/[a-z0-9.+-]+$/i.test(image.mime)
            ? `data:${image.mime};base64,${image.dataBase64}`
            : undefined);
    if (viewer.encryptedArtifacts && (!src || !/^data:image\//i.test(src)))
        return _jsx("span", { role: "status", children: "Attachment locked or unavailable" });
    return (_jsx("img", { className: className, src: src, alt: image.alt ?? 'Attachment', width: image.width, height: image.height }));
}
//# sourceMappingURL=ArtifactPresentation.js.map